var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('section',{class:{ ..._vm.basicClassName },attrs:{"id":_vm.id}},[_c('s-purchasing-version-2',{attrs:{"purchase-page-c-t-a":_vm.purchasePageCTA,"version":_vm.version,"page":_vm.page,"slice-settings-name":_vm.sliceSettingsName}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }